module.exports = __webpack_public_path__ + "img/xiao.a051e2c1.png";